module.exports = __webpack_public_path__ + "img/h1-boutique.76ae3155.png";